export function ManageChargifyCtrl (
  $state,
  $scope,
  $translate,
  messages,
  mobileApi,
  workshopAPI
) {
  $scope.chargify = {
    company_mobile              : $scope.company.mobile,
    company_phone               : $scope.company.phone,
    free_repco                  : $scope.company.free_repco,
    id                          : $scope.company.id,
    state                       : $scope.company.subscription_status || '',
    status_text                 : $scope.company.subscription_status,
    subscription_company_id     : $scope.company.subscription_company_id,
    subscription_customer_id    : $scope.company.subscription_customer_id,
    subscription_subdomain      : $scope.company.subscription_subdomain,
    subscription_subscription_id: $scope.company.subscription_subscription_id,
    unlock_code                 : $scope.company.unlock_code,
    video_storage_minutes       : $scope.company.video_storage_minutes
  };

  $scope.checkState = function () {
    if ($scope.chargify.state) {
      switch ( $scope.chargify.status_text.toLowerCase() ) {
        case 'active':
          return 'label-success';
        case 'trialing':
          return 'label-warning';
        case 'no subscription found':
          return 'label-primary';
        case 'canceled':
          return 'label-danger';
        case 'pending cancellation':
          return 'label-pending';
        default:
          return 'label-primary';
      }
    }
  };

  $scope.save = function (form) {
    workshopAPI.patch('/workshop_admin/update_chargify_information', $scope.chargify, 'company')
    .then(() => mobileApi.updateVideoMinutes($scope.chargify))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.CHARGIFY_ACCOUNT_UPDATED'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  workshopAPI.get('/system/subscription_subdomains/', null, 'subscription_subdomains')
  .then(data => {
    $scope.subscription_types = data;
  });
}